module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section05_02_american-village-af3e545129b008240c9583e7a47684df.jpg";